export const about = {
  hero: {
    title: 'About',
    titleHighlight: 'BULKCOM',
    description: 'Leading the transformation of global energy markets through innovative supply chain solutions, strategic partnerships, and unwavering commitment to operational excellence and sustainability.'
  },
  purpose: {
    title: 'Our Purpose',
    subtitle: 'Driving the future of energy distribution',
    mission: 'Mission Statement',
    missionText: 'To deliver reliable, cost-effective energy solutions that power industrial growth while maintaining the highest standards of safety, environmental responsibility, and operational excellence.',
    vision: 'Vision for 2030',
    visionText: 'To be the most trusted energy partner in Europe, recognized for innovation in supply chain optimization, commitment to carbon neutrality, and exceptional client service.',
    values: 'Core Values',
    valuesText: 'Integrity, Safety, Innovation, Sustainability, and Partnership guide every decision we make and every relationship we build.'
  },
  benefits: {
    title: 'Why Choose BULKCOM',
    subtitle: 'Competitive advantages that set us apart',
    globalNetwork: 'Global Network',
    globalNetworkDesc: 'Strategic partnerships across 50+ countries ensuring supply security and competitive pricing',
    expertise: '15+ Years Expertise',
    expertiseDesc: 'Deep industry knowledge and proven track record in complex energy markets',
    technology: 'Advanced Technology',
    technologyDesc: 'State-of-the-art SCADA systems and real-time monitoring for optimal performance',
    compliance: '100% Compliance',
    complianceDesc: 'Full regulatory adherence and industry certifications across all markets',
    support: '24/7 Support',
    supportDesc: 'Dedicated operations center providing continuous monitoring and rapid response',
    sustainability: 'ESG Commitment',
    sustainabilityDesc: 'Active carbon reduction programs and investment in renewable energy transition'
  },
  partnership: {
    title: 'Partnership Approach',
    subtitle: 'Building long-term relationships based on trust and mutual success',
    consultation: 'Consultation',
    consultationDesc: 'In-depth analysis of your energy requirements and operational constraints',
    solution: 'Solution Design',
    solutionDesc: 'Custom energy supply strategy aligned with your business objectives',
    implementation: 'Implementation',
    implementationDesc: 'Seamless integration with your existing infrastructure and processes',
    optimization: 'Optimization',
    optimizationDesc: 'Continuous monitoring and adjustment to maximize efficiency and value',
    cta: 'Start Your Partnership',
    ctaDesc: 'Connect with our team to explore how we can support your energy needs'
  }
};
